import React from 'react'

export default function Contact() {
    function myscript() {
        window.location = "mailto:jintu.kvs@gmail.com?body=&subject=Hello";
    }
    return (
        <div id="contact" className="w-11/12 max-w-5xl m-auto pb-40 mt-20">
            <h1 className="text-5xl text-center lg:text-6xl text-green-300 font-mono mb-10 font-black">Get In Touch</h1>
            <div className="text-black-100 text-xl flex flex-col items-center mt-20">
                <p className="text-center font-serif">Want to <span className="font-mono text-green-100">collab with me?</span></p>
                <p className="text-center font-serif">I am always open to discuss new ideas or work on some cool projects. Feel free to ping me or just say hello.</p>

                <p className="text-center">I will try my best to get back to you at the earliest. </p>

                <p className="mt-5 mb-10 text-center font-serif">You can also follow me on <span className="font-mono text-yellow-100">Codeforces</span> <a href="https://codeforces.com/profile/zefyrus" target="_blank" rel="noreferrer" className="italic text-green-100 hover:text-green-300"> ( @zefyrus )</a> and <span className="font-mono text-yellow-100">Codechef</span><a href="https://www.codechef.com/users/crowned" target="_blank" rel="noreferrer" className="italic text-green-100 hover:text-green-300"> ( @crowned )</a>.</p>

                <button className="text-green-100 p-4 border-2 border-green-100 rounded-full hover:border-green-300 hover:text-green-300" onClick={() => myscript()}>Say Hello 👋</button>
            </div>
        </div>
    )
}
